// title  标题
// tabbar: true 底部导航栏展示
// unpull: true 禁用下拉刷新
// unback: true, 不展示返回顶部按钮
// noheader: true 没有顶部
export default [
  {
    path: "yun/games",
    name: "yun.games",
    meta: {
      title: "即点即玩",
      tabbar: true,
      unback: true,
      noheader: true,
    },
    component: () => import("./YunGames.vue"),
  },
  {
    path: "yun/mygame",
    name: "yun.mygame",
    meta: {
      title: "我的小游戏",
      unpull: true,
      unback: true,
      noheader: true,
    },
    component: () => import("./MyYunGame.vue"),
  },
  {
    path: "yun/playing",
    name: "yun.playing",
    meta: {
      title: "秒玩游戏",
      unpull: true,
      unback: true,
      noheader: true,
    },
    component: () => import("./YunPlaying.vue"),
  },
];
